module.exports = __webpack_public_path__ + "static/media/BannerImage.4475dc39.png";